export const GoogleMapApiConfig = 'AIzaSyCMUh1v-k9Fk28NrQXmMMKFRn8CiE5oJ6c';